module.exports = __webpack_public_path__ + "static/media/Aphelios_0.03e0a918.jpg";